import { DEFAULT_APPEARANCE, type CharacterAppearance } from "@ghostland/shared";

type Listener = (a: CharacterAppearance) => void;

/**
 * The client's mirror of the LOCAL player's appearance during play. Fed from the
 * synced `Player.appearance` schema (updated on equip/unequip); the inventory preview
 * and the equipment slots subscribe to it. The server is authoritative.
 */
class AppearanceStore {
  private appearance: CharacterAppearance = { ...DEFAULT_APPEARANCE };
  private readonly listeners = new Set<Listener>();

  get(): CharacterAppearance {
    return this.appearance;
  }

  set(a: CharacterAppearance): void {
    this.appearance = a;
    for (const fn of this.listeners) fn(this.appearance);
  }

  /** Subscribe; immediately invoked with the current value. Returns unsubscribe. */
  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.appearance);
    return () => this.listeners.delete(fn);
  }
}

export const appearanceStore = new AppearanceStore();
